import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MAX_TRIES = 20;

function paidMessage(tx) {
  if (tx?.kind === "sentence_item") return `${tx.direction} sent · $${Number(tx.amount || 0).toFixed(2)} CAD added to the pot`;
  if (tx?.kind !== "sentence") return `${tx?.quantity ?? ""} provisions added to your bag`;
  const word = tx.direction === "extend" ? "extended" : "reduced";
  const applied = tx.applied_minutes ?? tx.quantity;
  return `sentence ${word} by ${applied} minute${applied === 1 ? "" : "s"}`;
}

export default function PaymentResultPage({ cancelled = false }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [tx, setTx] = useState(cancelled ? { kind: params.get("kind") } : null);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setTx(data);
        if (data.payment_status === "paid") { setState("paid"); if (data.kind === "provisions") refreshUser?.(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (e) {
        console.debug("payment status check failed", e);
      }
      tries += 1;
      if (tries >= MAX_TRIES) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, sessionId, refreshUser]);

  const sentence = tx?.kind === "sentence" || tx?.kind === "sentence_item";
  const msg = {
    checking: "confirming your payment…",
    paid: paidMessage(tx),
    failed: "payment did not go through",
    timeout: sentence ? "still processing. check the clock in a moment" : "still processing. check your bag in a moment",
    cancelled: "payment cancelled",
  }[state];

  return (
    <div className="max-w-md">
      <h1 className="font-head font-light text-4xl tracking-tighter mb-8" style={{ color: "var(--text-primary)" }}>{sentence ? "Sentence" : "Shop"}</h1>
      <p className="font-head text-xl mb-10" style={{ color: state === "paid" ? "var(--accent)" : "var(--text-secondary)" }} data-testid="payment-result-msg">
        {msg}
      </p>
      <button onClick={() => navigate(sentence ? "/home" : "/shop")} data-testid="payment-result-back-btn" className="btn px-6 py-3 text-sm tracking-widest">
        {sentence ? "BACK TO THE FEED" : "BACK TO SHOP"}
      </button>
    </div>
  );
}
